
// First, log to confirm the script is running at all
console.log("Offer button script initialized");
// Function to add helper text after the offer button
function addHelperText(offerButton) {
  if (!offerButton) return;
  
  console.log("Found offer button:", offerButton);
  
  // Check if helper text already exists
  if (offerButton.nextElementSibling?.classList.contains('offer-helper-text')) {
    return;
  }
  
  // Create the helper text element
  const helperText = document.createElement('p');
  helperText.className = 'offer-helper-text';
  helperText.textContent = 'This feature enables you to make an offer on this item.';
  
  // Style the helper text
  helperText.style.fontSize = '1rem';
  helperText.style.color = '#666';
  helperText.style.marginTop = '0px';
  helperText.style.padding = "0 !important"
  helperText.style.marginBottom = '5px';
  
  // Insert the helper text after the offer button
  offerButton.parentNode.insertBefore(helperText, offerButton.nextSibling);
  console.log('Helper text added to offer button');
}

// Try multiple selectors to find the offer button
function findOfferButton() {
  // Try by ID (your original approach)
  let offerButton = document.getElementById('offerButton');
  
 
  if (!offerButton) {
    offerButton = document.querySelector('.offerButton');
  }
  
 
  
  return offerButton;
}

// Check immediately and again after a short delay (for late-loading elements)
function checkForOfferButton() {
  console.log("Checking for offer button...");
  const offerButton = findOfferButton();
  if (offerButton) {
    addHelperText(offerButton);
    return true;
  }
  return false;
}

// Try on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  
const productDetail = document.querySelector(".product-detail");
  console.log("DOM content loaded",productDetail);
  
  if(productDetail){
  setTimeout(checkForOfferButton,1000);
  }  
});

